// Split a currency amount into whole-pound and pence digit strings for the
// HMRC SA108 per-digit box grid.
//
// Rounds to the nearest penny ONCE via integer cents, so a value whose pence
// round up to a full pound (e.g. 100.995) carries into the pounds column
// (£101.00). The previous inline approach floored the pounds first and then
// rounded the fractional part to pence, which produced pence === 100 and
// rendered "£100.10" — off by ~90p on a figure the user copies onto HMRC's
// return.
export const splitPoundsPence = (
  amount: number,
  poundWidth = 8
): { pounds: string[]; pence: string } => {
  const cents = Math.round((amount || 0) * 100);
  const sign = cents < 0 ? -1 : 1;
  const absCents = Math.abs(cents);
  const pounds = Math.floor(absCents / 100) * sign;
  const pence = absCents % 100;
  return {
    pounds: String(pounds).padStart(poundWidth, " ").split(""),
    pence: String(pence).padStart(2, "0"),
  };
};
